import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Breadcrumbs.css';

const Breadcrumb = ({ items }) => {
    // Construir Schema.org BreadcrumbList
    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.label,
            "item": item.link ? `https://contactame.com.ar${item.link}` : undefined
        }))
    };

    return (
        <>
            <Helmet>
                {/* Schema.org JSON-LD para Breadcrumbs */}
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbSchema)}
                </script>
            </Helmet>

            <div className="breadcrumb-container">
                {items.map((item, index) => {
                    // Si el item tiene icon, se renderiza el icono visualmente y
                    // el label queda accesible (sr-only) para lectores de pantalla / SEO.
                    const content = item.icon ? (
                        <>
                            <span className="breadcrumb-icon" aria-hidden="true">{item.icon}</span>
                            {item.label && <span className="breadcrumb-sr-only">{item.label}</span>}
                        </>
                    ) : (
                        item.label
                    );

                    return (
                        <React.Fragment key={index}>
                            {index > 0 && <span className="breadcrumb-separator">/</span>}
                            {item.link ? (
                                <Link to={item.link} className="breadcrumb-link">
                                    {content}
                                </Link>
                            ) : (
                                <span className="breadcrumb-current">{content}</span>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default Breadcrumb;
